module.exports = __webpack_public_path__ + "img/login-right-img.5bd729fd.jpg";